import {useAddress, useRoute} from '@yandex-taxi/react-integration-api'
import React from 'react'

import {TabName} from '../types'
import {parseValidAddresses} from '../utils'
import {useClasses} from './classes'
import {useGeolocationErrorNotification, useUpdateGeolocation} from './hooks'
import ResetBounds from './ResetBounds'
import ResetGeolocation from './ResetGeolocation'
import ZoomControl from './ZoomControl'

const FIRST_ADDRESS_INDEX = 0

type MapControlsProps = {
  tab: string
  id?: String
}

const MapControls: React.FC<MapControlsProps> = ({tab, id}) => {
  const classes = useClasses()
  const [{value: address}] = useAddress(FIRST_ADDRESS_INDEX)
  const [{value: route}] = useRoute()
  const [{loading, error}, {updateGeolocation}] = useUpdateGeolocation()
  const showGeolocationButton = !address || parseValidAddresses(route).length === 1

  useGeolocationErrorNotification(error)

  const orderButtons: JSX.Element = id && <ResetBounds />

  const draftButtons: JSX.Element = showGeolocationButton ? (
    <ResetGeolocation error={error} loading={loading} updateGeolocation={updateGeolocation} />
  ) : (
    <ResetBounds />
  )

  return (
    <div className={classes.container}>
      <div className={classes.buttonsWrap}>
        <ZoomControl />
        {tab === TabName.DRAFT && draftButtons}
        {tab === TabName.ORDERS && orderButtons}
      </div>
    </div>
  )
}

export default MapControls
